import React, { useEffect, useRef, useState } from "react";
import { apiResponse } from "../../../../utils/apiResponse";
import { apiCall } from "../../../../utils/axiosService";
import { API_URL } from "../../../../utils/apiRoutes";
import { commonService } from "../../../../utils/commonService";
import { Button, Col, Table } from "react-bootstrap";
import DatePicker from "react-datepicker";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import Loader from "../../../Loader/Loader";
import WidgetNote from "../../WidgetNote";
import WidgetDetailModal from "../../WidgetDetailModal";
import { useSelector } from "react-redux";
import { compName } from "../../../../utils/constant";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import moment from "moment";

const BestWesternReservationForecast = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const tableData = [
    {
      id: 1,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 2,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 3,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 4,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 5,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 6,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 7,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 8,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 9,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
    {
      id: 10,
      asOfDate: "-",
      propertyCode: "-",
      pullDateId: "0",
      textBox37: "0",
      textBox11: "-",
      textBox40: "0",
      textBox7: "0",
      textBox41: "0",
      textBox12: "0",
      textBox42: "0",
      textBox16: "0",
      textBox43: "0",
      textBox20: "0",
      textBox44: "0",
      textBox24: "0",
      textBox25: "0",
      textBox85: "0",
      textBox86: "0",
      textBox46: "0",
      textBox26: "0",
      textBox47: "0",
      textBox27: "0",
      textBox48: "0",
      textBox28: "0",
      textBox49: "0",
      textBox29: "0",
      textBox79: "0",
      textBox80: "0",
      textBox50: "0",
      textBox30: "0",
      textBox51: "0",
      textBox31: "0",
      textBox52: "0",
      textBox32: "0",
      textBox53: "0",
      textBox33: "0",
      textBox54: "0",
      textBox34: "0",
      textBox55: "0",
      textBox35: "0",
      textBox56: "0",
      textBox36: "0",
      textBox57: "0",
      textBox38: "0",
      textBox58: "0",
      textBox60: "0",
      textBox61: "0",
      textBox62: "0",
      textBox63: "0",
      textBox64: "0",
      textBox65: "0",
      textBox87: "0",
      textBox66: "0",
      textBox67: "0",
      textBox68: "0",
      textBox69: "0",
      textBox81: "0",
      textBox70: "0",
      textBox71: "0",
      textBox72: "0",
      textBox73: "0",
      textBox74: "0",
      textBox75: "0",
      textBox76: "0",
      textBox77: "0",
      textBox181: "0",
      textBox136: "0",
      textBox185: "0",
      textBox130: "0",
      textBox186: "0",
      textBox139: "0",
      textBox189: "0",
      textBox145: "0",
      textBox190: "0",
      textBox151: "0",
      textBox191: "0",
      textBox159: "0",
      textBox192: "0",
      textBox160: "0",
      textBox88: "0",
      textBox89: "0",
      textBox193: "0",
      textBox161: "0",
      textBox194: "0",
      textBox164: "0",
      textBox195: "0",
      textBox165: "0",
      textBox196: "0",
      textBox166: " ",
      textBox82: "0",
      textBox83: "0",
      textBox197: "0",
      textBox169: "0",
      textBox198: "0",
      textBox170: "0",
      textBox199: "0",
      textBox171: " ",
      textBox200: "0",
      textBox174: " ",
      textBox201: "0",
      textBox175: "0",
      textBox202: "0",
      textBox176: "0",
      textBox203: "0",
      textBox179: "0",
      textBox204: "0",
      textBox180: "0",
      textBox2: "0",
      textBox4: "0",
      textBox5: "0",
      textBox6: "0",
      textBox8: "0",
      textBox9: "0",
      textBox10: "0",
      textBox90: "0",
      textBox13: "0",
      textBox14: "0",
      textBox15: "0",
      textBox17: "0",
      textBox84: "0",
      textBox18: "0",
      textBox19: "0",
      textBox21: "0",
      textBox22: "0",
      textBox23: "0",
      textBox39: "0",
      textBox59: "0",
      textBox78: "0",
    },
  ];

  const [reservationForecast, setReservationForecast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [startRangeDate, setStartRangeDate] = useState();
  const [endRangeDate, setEndRangeDate] = useState();
  const startRangeDateRef = useRef();
  const endRangeDateRef = useRef();
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeWidgetModal = () => {
    setWidgetModal(false);
  };
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };
  const handleDateChange = (event) => {
    const [start, end] = event;
    let startSelectedDate = "",
      endSelectedDate = "";
    if (start) {
      let date = new Date(start);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      startSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      startRangeDateRef.current = startSelectedDate;
    }
    if (end) {
      let date = new Date(end);
      let month =
        date.getMonth() + 1 > 9
          ? date.getMonth() + 1
          : `0${date.getMonth() + 1}`;
      let dateFormat =
        date?.getDate() > 9 ? date.getDate() : `0${date.getDate()}`;
      endSelectedDate = `${date.getFullYear()}-${month}-${dateFormat}`;
      endRangeDateRef.current = endSelectedDate;
    }

    setStartRangeDate(event[0]);
    setEndRangeDate(event[1]);
    if (event[0] !== null && event[1] !== null) {
      // getReservationForecast();
    }
  };

  const getReservationForecast = async () => {
    setLoading(true);
    let payload = {
      AsOfDate: para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    if (startRangeDateRef.current && endRangeDateRef.current) {
      payload = {
        ...payload,
        startDate: startRangeDateRef.current,
        endDate: endRangeDateRef.current,
      };
    }
    let reservationForecastResponse = await apiCall(
      {
        method: "POST",
        url:
          API_URL.BASE_API_URL.SnapShot +
          API_URL.WIDGET_MODULE.BEST_WESTERN_RESERVATION_FORECAST,
        body: payload,
      },
      false
    );

    let response = apiResponse(false, reservationForecastResponse);

    if (response?.isValidate) {
      setLoading(false);
      setReservationForecast(response?.data?.data);
    }

    if (!response?.isValidate) {
      setLoading(false);
      setReservationForecast(null);
    }
  };

  useEffect(() => {
    if (api === 0) {
      setReservationForecast(tableData);
    } else {
      if (para?.asOfDate) {
        getReservationForecast();
      }
    }
  }, [para?.asOfDate]);

  const [tblids, settblids] = useState({
    tblBestWesternReservationForecast: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "menuicon", propertyCode)}
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.tblBestWesternReservationForecast,
                  "Best Western Reservation Forecast",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.widgetBestWesternReservationForecast,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "downloadIcon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.tblBestWesternReservationForecast}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.tblBestWesternReservationForecast,
                  // "Best Western Reservation Forecast"
                  `${
                    para?.propertyCode
                  }-Best Western Reservation Forecast-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
          <Table
            responsive
            id={tblids.tblBestWesternReservationForecast}
            className="positionStaticTable"
          >
            <thead>
              <tr>
                <th id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "date-picker", propertyCode)}
                  className="width175"
                  onClick={() => {
                    setOpenDatePicker(true);
                  }}
                >
                  Date{" "}
                                  <DatePicker id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "date-picker", propertyCode)}
                                      portalId="datepicker-root"
                    onChange={(event) => handleDateChange(event)}
                    startDate={startRangeDate}
                    endDate={endRangeDate}
                    selectsRange
                    monthsShown={2}
                    open={openDatePicker}
                    shouldCloseOnSelect={false}
                  >
                    <div className="w-100" style={{ display: "inline-block" }}>
                      <div className="content-inside-calendar">
                        <p>
                          {startRangeDate
                            ? commonService.getDateInFormat(startRangeDate)
                            : ""}
                          {startRangeDate && endRangeDate ? " - " : ""}
                          {endRangeDate
                            ? commonService.getDateInFormat(endRangeDate)
                            : ""}
                        </p>
                        <div className="d-flex align-items-center gap-2">
                          <button id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "date-cancel-btn", propertyCode)}
                            className="secondary-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              setStartRangeDate("");
                              setEndRangeDate("");
                              setOpenDatePicker(false);
                            }}
                          >
                            Cancel
                          </button>
                          <button id={commonService.generateGlobalClickTrackerID("BestWesternReservationForecast", "date-apply-btn", propertyCode)}
                            disabled={
                              startRangeDate && endRangeDate ? false : true
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              if (
                                startRangeDateRef.current &&
                                endRangeDateRef.current
                              ) {
                                getReservationForecast();
                              }

                              setOpenDatePicker(false);
                            }}
                            className="primary-btn"
                          >
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </DatePicker>
                  {startRangeDate && endRangeDate && (
                    <span
                      style={{ display: "none" }}
                    >{`${commonService.getDateInFormat(
                      startRangeDate
                    )} - ${commonService.getDateInFormat(endRangeDate)}`}</span>
                  )}
                </th>
                <th colSpan={127}></th>
              </tr>
              <tr className="text-center">
                <th className="width100 text-start">asOfDate</th>
                {/* <th className="width100">propertyCode</th>
                <th className="width100">pullDateId</th> */}
                <th className="width100">textBox37</th>
                <th className="width100">textBox11</th>
                <th className="width100">textBox40</th>
                <th className="width100">textBox7</th>
                <th className="width100">textBox41</th>
                <th className="width100">textBox12</th>
                <th className="width100">textBox42</th>
                <th className="width100">textBox16</th>
                <th className="width100">textBox43</th>
                <th className="width100">textBox20</th>
                <th className="width100">textBox44</th>
                <th className="width100">textBox24</th>
                <th className="width100">textBox25</th>
                <th className="width100">textBox85</th>
                <th className="width100">textBox86</th>
                <th className="width100">textBox46</th>
                <th className="width100">textBox26</th>
                <th className="width100">textBox47</th>
                <th className="width100">textBox27</th>
                <th className="width100">textBox48</th>
                <th className="width100">textBox28</th>
                <th className="width100">textBox49</th>
                <th className="width100">textBox29</th>
                <th className="width100">textBox79</th>
                <th className="width100">textBox80</th>
                <th className="width100">textBox50</th>
                <th className="width100">textBox30</th>
                <th className="width100">textBox51</th>
                <th className="width100">textBox31</th>
                <th className="width100">textBox52</th>
                <th className="width100">textBox32</th>
                <th className="width100">textBox53</th>
                <th className="width100">textBox33</th>
                <th className="width100">textBox54</th>
                <th className="width100">textBox34</th>
                <th className="width100">textBox55</th>
                <th className="width100">textBox35</th>
                <th className="width100">textBox56</th>
                <th className="width100">textBox36</th>
                <th className="width100">textBox57</th>
                <th className="width100">textBox38</th>
                <th className="width100">textBox58</th>
                <th className="width100">textBox60</th>
                <th className="width100">textBox61</th>
                <th className="width100">textBox62</th>
                <th className="width100">textBox63</th>
                <th className="width100">textBox64</th>
                <th className="width100">textBox65</th>
                <th className="width100">textBox87</th>
                <th className="width100">textBox66</th>
                <th className="width100">textBox67</th>
                <th className="width100">textBox68</th>
                <th className="width100">textBox69</th>
                <th className="width100">textBox81</th>
                <th className="width100">textBox70</th>
                <th className="width100">textBox71</th>
                <th className="width100">textBox72</th>
                <th className="width100">textBox73</th>
                <th className="width100">textBox74</th>
                <th className="width100">textBox75</th>
                <th className="width100">textBox76</th>
                <th className="width100">textBox77</th>
                <th className="width100">textBox181</th>
                <th className="width100">textBox136</th>
                <th className="width100">textBox185</th>
                <th className="width100">textBox130</th>
                <th className="width100">textBox186</th>
                <th className="width100">textBox139</th>
                <th className="width100">textBox189</th>
                <th className="width100">textBox145</th>
                <th className="width100">textBox190</th>
                <th className="width100">textBox151</th>
                <th className="width100">textBox191</th>
                <th className="width100">textBox159</th>
                <th className="width100">textBox192</th>
                <th className="width100">textBox160</th>
                <th className="width100">textBox88</th>
                <th className="width100">textBox89</th>
                <th className="width100">textBox193</th>
                <th className="width100">textBox161</th>
                <th className="width100">textBox194</th>
                <th className="width100">textBox164</th>
                <th className="width100">textBox195</th>
                <th className="width100">textBox165</th>
                <th className="width100">textBox196</th>
                <th className="width100">textBox166</th>
                <th className="width100">textBox82</th>
                <th className="width100">textBox83</th>
                <th className="width100">textBox197</th>
                <th className="width100">textBox169</th>
                <th className="width100">textBox198</th>
                <th className="width100">textBox170</th>
                <th className="width100">textBox199</th>
                <th className="width100">textBox171</th>
                <th className="width100">textBox200</th>
                <th className="width100">textBox174</th>
                <th className="width100">textBox201</th>
                <th className="width100">textBox175</th>
                <th className="width100">textBox202</th>
                <th className="width100">textBox176</th>
                <th className="width100">textBox203</th>
                <th className="width100">textBox179</th>
                <th className="width100">textBox204</th>
                <th className="width100">textBox180</th>
                <th className="width100">textBox2</th>
                <th className="width100">textBox4</th>
                <th className="width100">textBox5</th>
                <th className="width100">textBox6</th>
                <th className="width100">textBox8</th>
                <th className="width100">textBox9</th>
                <th className="width100">textBox10</th>
                <th className="width100">textBox90</th>
                <th className="width100">textBox13</th>
                <th className="width100">textBox14</th>
                <th className="width100">textBox15</th>
                <th className="width100">textBox17</th>
                <th className="width100">textBox84</th>
                <th className="width100">textBox18</th>
                <th className="width100">textBox19</th>
                <th className="width100">textBox21</th>
                <th className="width100">textBox22</th>
                <th className="width100">textBox23</th>
                <th className="width100">textBox39</th>
                <th className="width100">textBox59</th>
                <th className="width100">textBox78</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : reservationForecast && reservationForecast?.length > 0 ? (
                reservationForecast?.map((item) => (
                  <tr key={item?.id} className="text-center shadowOnHover">
                    <td className="text-start">
                      {item?.asOfDate
                        ? commonService.getDateInFormat(item?.asOfDate)
                        : ""}
                    </td>
                    {/* <td>{item?.propertyCode}</td>
                    <td>{item?.pullDateId}</td> */}
                    <td>{item?.textBox37}</td>
                    <td>
                      {item?.textBox11
                        ? commonService.getDateInFormat(item?.textBox11)
                        : ""}
                    </td>
                    <td>{item?.textBox40}</td>
                    <td>{item?.textBox7}</td>
                    <td>{item?.textBox41}</td>
                    <td>{item?.textBox12}</td>
                    <td>{item?.textBox42}</td>
                    <td>{item?.textBox16}</td>
                    <td>{item?.textBox43}</td>
                    <td>{item?.textBox20}</td>
                    <td>{item?.textBox44}</td>
                    <td>{item?.textBox24}</td>
                    <td>{item?.textBox25}</td>
                    <td>{item?.textBox85}</td>
                    <td>{item?.textBox86}</td>
                    <td>{item?.textBox46}</td>
                    <td>{item?.textBox26}</td>
                    <td>{item?.textBox47}</td>
                    <td>{item?.textBox27}</td>
                    <td>{item?.textBox48}</td>
                    <td>{item?.textBox28}</td>
                    <td>{item?.textBox49}</td>
                    <td>{item?.textBox29}</td>
                    <td>{item?.textBox79}</td>
                    <td>{item?.textBox80}</td>
                    <td>{item?.textBox50}</td>
                    <td>{item?.textBox30}</td>
                    <td>{item?.textBox51}</td>
                    <td>{item?.textBox31}</td>
                    <td>{item?.textBox52}</td>
                    <td>{item?.textBox32}</td>
                    <td>{item?.textBox53}</td>
                    <td>{item?.textBox33}</td>
                    <td>{item?.textBox54}</td>
                    <td>{item?.textBox34}</td>
                    <td>{item?.textBox55}</td>
                    <td>{item?.textBox35}</td>
                    <td>{item?.textBox56}</td>
                    <td>{item?.textBox36}</td>
                    <td>{item?.textBox57}</td>
                    <td>{item?.textBox38}</td>
                    <td>{item?.textBox58}</td>
                    <td>{item?.textBox60}</td>
                    <td>{item?.textBox61}</td>
                    <td>{item?.textBox62}</td>
                    <td>{item?.textBox63}</td>
                    <td>{item?.textBox64}</td>
                    <td>{item?.textBox65}</td>
                    <td>{item?.textBox87}</td>
                    <td>{item?.textBox66}</td>
                    <td>{item?.textBox67}</td>
                    <td>{item?.textBox68}</td>
                    <td>{item?.textBox69}</td>
                    <td>{item?.textBox81}</td>
                    <td>{item?.textBox70}</td>
                    <td>{item?.textBox71}</td>
                    <td>{item?.textBox72}</td>
                    <td>{item?.textBox73}</td>
                    <td>{item?.textBox74}</td>
                    <td>{item?.textBox75}</td>
                    <td>{item?.textBox76}</td>
                    <td>{item?.textBox77}</td>
                    <td>{item?.textBox181}</td>
                    <td>{item?.textBox136}</td>
                    <td>{item?.textBox185}</td>
                    <td>{item?.textBox130}</td>
                    <td>{item?.textBox186}</td>
                    <td>{item?.textBox139}</td>
                    <td>{item?.textBox189}</td>
                    <td>{item?.textBox145}</td>
                    <td>{item?.textBox190}</td>
                    <td>{item?.textBox151}</td>
                    <td>{item?.textBox191}</td>
                    <td>{item?.textBox159}</td>
                    <td>{item?.textBox192}</td>
                    <td>{item?.textBox160}</td>
                    <td>{item?.textBox88}</td>
                    <td>{item?.textBox89}</td>
                    <td>{item?.textBox193}</td>
                    <td>{item?.textBox161}</td>
                    <td>{item?.textBox194}</td>
                    <td>{item?.textBox164}</td>
                    <td>{item?.textBox195}</td>
                    <td>{item?.textBox165}</td>
                    <td>{item?.textBox196}</td>
                    <td>{item?.textBox166}</td>
                    <td>{item?.textBox82}</td>
                    <td>{item?.textBox83}</td>
                    <td>{item?.textBox197}</td>
                    <td>{item?.textBox169}</td>
                    <td>{item?.textBox198}</td>
                    <td>{item?.textBox170}</td>
                    <td>{item?.textBox199}</td>
                    <td>{item?.textBox171}</td>
                    <td>{item?.textBox200}</td>
                    <td>{item?.textBox174}</td>
                    <td>{item?.textBox201}</td>
                    <td>{item?.textBox175}</td>
                    <td>{item?.textBox202}</td>
                    <td>{item?.textBox176}</td>
                    <td>{item?.textBox203}</td>
                    <td>{item?.textBox179}</td>
                    <td>{item?.textBox204}</td>
                    <td>{item?.textBox180}</td>
                    <td>{item?.textBox2}</td>
                    <td>{item?.textBox4}</td>
                    <td>{item?.textBox5}</td>
                    <td>{item?.textBox6}</td>
                    <td>{item?.textBox8}</td>
                    <td>{item?.textBox9}</td>
                    <td>{item?.textBox10}</td>
                    <td>{item?.textBox90}</td>
                    <td>{item?.textBox13}</td>
                    <td>{item?.textBox14}</td>
                    <td>{item?.textBox15}</td>
                    <td>{item?.textBox17}</td>
                    <td>{item?.textBox84}</td>
                    <td>{item?.textBox18}</td>
                    <td>{item?.textBox19}</td>
                    <td>{item?.textBox21}</td>
                    <td>{item?.textBox22}</td>
                    <td>{item?.textBox23}</td>
                    <td>{item?.textBox39}</td>
                    <td>{item?.textBox59}</td>
                    <td>{item?.textBox78}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="text-center" colSpan={128}>
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {/* {showNoteSidebar && (
        <WidgetNote
          show={showNoteSidebar}
          handleClose={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )} */}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default BestWesternReservationForecast;
